import {useAppSelector} from "../../../redux/hooks";
import {dashboardStore} from "../store/dashboardPageStore";
import {IDashboardPageBootcampCourseProgress} from "../store/IDashboardPageStore";

export interface IBootcampProgressLogic {
  rookie: Optional<IDashboardPageBootcampCourseProgress>;
  intermediate: Optional<IDashboardPageBootcampCourseProgress>;
  advanced: Optional<IDashboardPageBootcampCourseProgress>;
}

export const useBootcampProgressLogic = (): IBootcampProgressLogic => {
  const {rookie, intermediate, advanced} = useAppSelector(dashboardStore.getBootcampProgress);
  return {
    rookie,
    intermediate,
    advanced,
  };
}
